var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    var _a;
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Title', value: props.response.data.title },
            { label: 'Display Order', value: (_a = props.response.data.displayOrder) !== null && _a !== void 0 ? _a : React.createElement("em", null, "(not set)") },
        ] }));
};
const formConfig = {
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.text',
            key: 'title',
            label: 'Title',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.number',
            key: 'displayOrder',
            label: 'Display Order',
        },
        {
            type: 'form.text',
            key: 'description',
            label: 'Description',
            emptyAsNull: true,
        },
        {
            type: 'form.text',
            key: 'key',
            label: 'Key',
            emptyAsNull: true,
        },
    ],
};
const csvFileHeader = ['ID', 'Name', 'Title', 'Status', 'Display Order', 'Description', 'Key'];
function mapCsvRowToData(row) {
    var _a, _b, _c, _d, _e, _f, _g;
    const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
    const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
    const title = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim();
    const status = ((_d = row.data[3]) !== null && _d !== void 0 ? _d : '').trim().toLowerCase();
    const displayOrder = ((_e = row.data[4]) !== null && _e !== void 0 ? _e : '').trim();
    const description = ((_f = row.data[5]) !== null && _f !== void 0 ? _f : '').trim();
    const key = ((_g = row.data[6]) !== null && _g !== void 0 ? _g : '').trim();
    if (name.length === 0) {
        row.errors.push('Name is required');
    }
    if (title.length === 0) {
        row.errors.push('Title is required');
    }
    if (status.length === 0) {
        row.errors.push('Status is required');
    }
    switch (status) {
        case 'active':
        case 'deprecated':
        case 'retired':
            break;
        default:
            row.errors.push('Invalid status, expected one of: active, deprecated, retired');
    }
    let displayOrderNumber;
    if (displayOrder) {
        displayOrderNumber = parseFloat(displayOrder);
        if (!isFinite(displayOrderNumber)) {
            row.errors.push('Invalid display number, expected a number');
            displayOrderNumber = undefined;
        }
    }
    if (row.errors.length === 0) {
        row.object = {
            id: id,
            data: {
                name: name,
                title: title,
                status: status,
                displayOrder: displayOrderNumber,
                description: description,
                key: key,
            },
        };
    }
    return Promise.resolve(row);
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return [
            response.id,
            response.data.name,
            response.data.title,
            response.data.status,
            response.data.displayOrder != null ? response.data.displayOrder.toString() : '',
            response.data.description != null ? response.data.description : '',
            response.data.key != null ? response.data.key : '',
        ];
    });
}
export const GroupSectionAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: 'groupSection', title: 'Group Section', fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, entityDetailsEditForm: true, entityDetailsPreviewForm: true, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
